import React, { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import DropDownSingle from '../../../../Components/DropDownSingle';
import constants from './constants.json';
//mui imports====
import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';
import PageHeading from '../../../../Components/PageHeading';

const AdUnitsConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const { adUnitsOrderList } = constants;
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Ad Units Config"
				headingPath={['Dashboard', 'Framerate', 'Network Data', 'Ad Units Config']}
				description="Manage Custom Ad Unit Configurations"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={0} style={{ margin: '5rem 0 5rem 5rem', width: '95%' }}>
				<Grid xs={3} item>
					<DropDownSingle
						keyData={keyData + '.adUnitsOrder'}
						list={adUnitsOrderList}
						label={'AdUnits Order'}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default AdUnitsConfig;
